// src/components/ThemeToggle.tsx - Simplified Version
import React, { memo } from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = memo(() => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle"
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? '🌙' : '☀️'}
      {theme === 'light' ? ' Dark' : ' Light'}
    </button>
  );
});

ThemeToggle.displayName = 'ThemeToggle';

export default ThemeToggle;